export const documentModalActions = {
  copy: 'COPY',
  remove: 'REMOVE',
  duplicate: 'DUPLICATE',
  update: 'UPDATE',
  updateMeta: 'UPDATE META',
  merge: 'MERGE',
  replace: 'REPLACE',
  split: 'SPLIT',
  removePages: 'REMOVE PAGES',
  generateHyperlinks: 'GENERATE HYPERLINKS',
  generateTranscriptsbasedHyperlinks: 'GENERATE TRANSCRIPT HYPERLINKS',
  findAndReplaceHyperlinks: 'FIND AND REPLACE HYPERLINKS',
  previewHyperlinks: 'PREVIEW HYPERLINKS',
  previewHyperlinksWithDiscoveryID: 'PREVIEW HYPERLINKS WITH DISCOVERY ID',
  manageHyperlinks: 'MANAGE HYPERLINKS',
  moreInfo: 'MORE INFO',
  fileVersions: 'FILE VERSIONS',
  download: 'DOWNLOAD',
  fileVariants: 'FILE VARIANTS',
  uploadTranscriptNotes: 'UPLOAD TRANSCRIPT NOTES',
  previewTranscriptNotes: 'PREVIEW TRANSCRIPT NOTES',
  changePosition: 'CHANGE POSITION',
  updateReferences: 'UPDATE REFERENCES',
  takeReference: 'TAKE REFERENCE',
  takeReferenceWithNames: 'TAKE REFERENCE WITH NAMES',
  exhibitChanges: 'EXHIBIT CHANGES',
  exhibitNumberHyperlinks: 'EXHIBIT NUMBER HYPERLINKS',
};

export const folderModalActions = {
  moveToTrialBooks: 'MOVE TO TRIALBOOKS',
  removeFromGroupBundles: 'REMOVE FROM GROUP BUNDLES',
  removeFromTrialBooks: 'REMOVE FROM TRIALBOOKS',
  moveToCourtBundles: 'MOVE',
  removeFromCourtBundles: 'REMOVE',
  createTeamBundle: 'CREATE TEAM BUNDLE',
  createPrivateBundle: 'CREATE PRIVATE BUNDLE',
  updateBundle: 'UPDATE',
  createBundle: 'ADD',
  deleteBundle: 'DELETE',
  mergeBundle: 'MERGE',
  createTrialbook: 'ADD TRIALBOOK',
  agreeTrialbook: 'AGREE',
  mergeTrialbook: 'MERGE TRIALBOOK',
  updateTrialbook: 'UPDATE TRIALBOOK',
  bulkUpdateFiles: 'BULK UPDATE FILES',
  updateExhibitNumbers: 'UPDATE EXHIBIT NUMBERS',
  deleteTrialbook: 'DELETE TRIALBOOK',
  showHistory: 'SHOW HISTORY',
  refresh: 'REFRESH',
  createTag: 'CREATE TAG',
  updateTag: 'UPDATE TAG',
  deleteTag: 'DELETE TAG',
  burnCrossRef: 'BURN CROSS REF',
  reIndex: 'RE INDEX',
  classify: 'CLASSIFY',
  healthCheck: 'HEALTH CHECK',
  createTimeline: 'CREATE TIMELINE',
  updateTimeline: 'UPDATE TIMELINE',
  deleteTimeline: 'DELETE TIMELINE',
  exportTimeline: 'EXPORT TIMELINE',
  exportFolder: 'EXPORT FOLDER',
  downloadFolder: 'DOWNLOAD FOLDER',
  deleteAll: 'DELETE ALL',
  clone: 'CLONE',
  convertToBundle: 'CONVERT TO BUNDLE',
  batchUpload: 'BATCH UPLOAD',
  share: 'SHARE',
  shareWithGroup: 'SHARE WITH GROUP',
  reposition: 'REPOSITION',
  assignFilesFromCSV: 'ASSIGN FILES FROM CSV',
};

export const fileTypes = {
  mp4: 'mp4',
};

export const teamAdminModal = {
  addMember: 'ADD MEMBER',
  removeMember: 'REMOVE MEMBER',
  inviteMember: 'INVITE MEMBER',
  updateMember: 'UPDATE MEMBER',
  getInviteLink: 'GET INVITE LINK',
  getActivityLogs: 'GET ACTIVITY LOGS',
  changeHearingRoomPosition: 'CHANGE HEARING ROOM POSITION',
  systemTestResult: 'SYSTEM TEST RESULT',
  removeSystemTestResult: 'REMOVE SYSTEM TEST RESULT',
  reSendInvite: 'RESEND INVITE',
  changeTeam: 'CHANGE TEAM',
  loginHistory: 'LOGIN HISTORY',
  bulkUpload: 'BULK UPLOAD',
  updatePhoneNumber: 'UPDATE PHONE NUMBER',
};

export const caseAdminModalActions = {
  addNewTeam: 'ADD NEW TEAM',
  updateTeamName: 'UPDATE TEAM NAME',
  removeTeam: 'REMOVE TEAM',
  addNewGroup: 'ADD NEW GROUP',
  removeGroup: 'REMOVE GROUP',
};

export const caseRolesModalAction = {
  addNewMember: 'ADD NEW MEMBER',
  removeMember: 'REMOVE MEMBER',
};

export const annotationsTableAction = {
  update: 'UPDATE',
  delete: 'DELETE',
  deleteAnnotaion: 'DELETE ANNOTATION',
  addNewEvent: 'ADD NEW EVENT',
  share: 'SHARE',
  unshare: 'UNSHARE',
};

export const confidentialityRingCategoryLabel = {
  innerRing: 'Inner Ring',
  outerRing: 'Outer Ring',
  noRing: 'No Ring',
};

export const suggestedRecipientsMenuOptions = {
  addAll: 'ADD ALL',
};
